import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { UnleashClient } from 'unleash-proxy-client';
import { Observable, Subject } from 'rxjs';

export const UNLEASH_APP_NAME = new InjectionToken<string>('UNLEASH_APP_NAME');
export const UNLEASH_PRODUCTION_MODE = new InjectionToken<boolean>('UNLEASH_PRODUCTION_MODE');

const UNLEASH_PROXY_PATH = '/api/feature-flags/';

@Injectable({
  providedIn: 'root',
})
export class UnleashFeatureFlagService {
  readonly updates$: Observable<void>;

  private readonly updatesSubject = new Subject<void>();
  private readonly client: UnleashClient | null;
  private readonly proxyClientKey = 'frontend-proxy';

  constructor(
    @Optional() @Inject(UNLEASH_APP_NAME) unleashAppName: string | null,
    @Optional() @Inject(UNLEASH_PRODUCTION_MODE) private readonly production: boolean | null,
  ) {
    this.updates$ = this.updatesSubject.asObservable();

    if (!unleashAppName) {
      this.client = null;
      return;
    }

    this.client = new UnleashClient({
      url: new URL(UNLEASH_PROXY_PATH, window.location.origin).toString(),
      clientKey: this.proxyClientKey,
      appName: unleashAppName,
    });

    this.client.on('ready', () => this.updatesSubject.next());
    this.client.on('update', () => this.updatesSubject.next());
    this.client.on('error', error => {
      if (this.production) {
        console.error('feature flag fetch failed');
      } else {
        console.error('[Unleash] feature flag fetch failed, flags default to disabled', error);
      }
      this.updatesSubject.next();
    });
    this.client.start();
  }

  isEnabled(flagName: string, fallback = false): boolean {
    return this.client ? this.client.isEnabled(flagName) : fallback;
  }
}